import type { SVGProps } from 'react';

const SvgArrowDownLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M6 14L12 20L18 14' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M12 4L12 20' stroke='currentColor' strokeMiterlimit={10} strokeLinecap='round' />
  </svg>
);
export default SvgArrowDownLt;
